enum BanCertificationType {
  CERTIFIED = 'CERTIFIED',
  NOT_CERTIFIED = 'NOT_CERTIFIED'
}

export default BanCertificationType;
